import * as React from "react";

import { Doc } from "affinityUI/structures/doc";

import patientTrainingConfirmation from "./assets/Patient training confirmation.png";
import patientTrainingStatus from "./assets/Patient training status.png";
export const PatientTrainingSection: React.FC = () => {
  return (
    <Doc.Section title="Patient Training">
      <p>
        Entia will provide virtual 1:1 training to each patient before they start to use the Liberty device. Information
        about training will be presented in the Device Details section on the Review Patient page.
      </p>
      <Doc.Illustration src={patientTrainingStatus} label="Patient training status" />
      <p>
        As soon as the patient has completed training, Entia will mark it on the Entia Liberty Dashboard. This
        information will be presented in the same Device Details section.
      </p>
      <Doc.Illustration src={patientTrainingConfirmation} label="Patient training confirmation" />
    </Doc.Section>
  );
};
